const VIDEO_THOUGHTS = [
  {
    caption:
      "Dr.'s Michael Bain, Dan Davis, and Windy Cole talk about the urgency to treat",
    src: 'https://organogenesis-all-media-files.s3.us-west-2.amazonaws.com/woundscantwait.com/social-mix.webm',
    thumbnail: '/images/hcp-videos-thumbnail.webp',
    preview: '/images/dr-michael-bain-video-thumbnail.webp',
  },
  {
    caption:
      'Dr. George Koullias talks about challenges in healing open wounds',
    src: 'https://organogenesis-all-media-files.s3.us-west-2.amazonaws.com/woundscantwait.com/social-video-dr-koullias.webm',
    thumbnail: '/images/hcp-videos-thumbnail.webp',
    preview: '/images/dr-george-koullias-video-thumbnail.webp',
  },
];

export { VIDEO_THOUGHTS };
